module.exports = __webpack_public_path__ + "static/media/bg3.e17669f8.jpg";